import styled from 'styled-components';

import Text from '@/v2/components/Typography/Text';

export const Description = styled(Text)`
  display: block;
  margin-top: 8px;
  white-space: pre-line;
  line-height: 16px;
`;
